export default __webpack_public_path__ + "static/media/primary.a8ab83b58e6d2efb680b60e43ea89d0f.svg";